module.exports = __webpack_public_path__ + "static/AccessSecret-9a0e6ba46f95b4e425dbb0275a994002.png";